import {CSSProperties, FC} from 'react';


export interface IIconAirbagProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconAirbag: FC<IIconAirbagProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="m11.65 14.452.58 1.403H10.55a.878.878 0 0 0-.84.631l-1.284 4.44-1.348-.39 1.285-4.44a2.288 2.288 0 0 1 2.187-1.644h1.1Zm2.924-9.348c0-1.16.944-2.104 2.105-2.104 1.16 0 2.104.944 2.104 2.104 0 1.16-.944 2.105-2.104 2.105a2.107 2.107 0 0 1-2.105-2.105Zm1.403 0a.702.702 0 1 0 1.405 0 .702.702 0 0 0-1.405 0Zm-.758 10.638 1.898 4.597-1.297.536-3.22-7.801.018-.008.979-3.612c.16-.54.52-.984 1.017-1.249a2.104 2.104 0 0 1 1.59-.163c.54.15.99.502 1.268.993l.017.032 2.725-1.843L21 8.386l-3.325 2.249v.001l-.997 3.655c-.193.711-.725 1.224-1.46 1.45Zm.106-1.82.996-3.655a.712.712 0 0 0-.493-.873l-.014-.004a.71.71 0 0 0-.539.053.678.678 0 0 0-.331.402l-.856 3.159.59 1.43c.268-.055.56-.19.647-.512ZM7.56 12.12A4.565 4.565 0 0 1 3 7.56 4.565 4.565 0 0 1 7.56 3a4.565 4.565 0 0 1 4.56 4.56 4.565 4.565 0 0 1-4.56 4.56Zm0-1.403a3.16 3.16 0 0 0 3.156-3.156A3.16 3.16 0 0 0 7.56 4.403 3.16 3.16 0 0 0 4.403 7.56a3.16 3.16 0 0 0 3.157 3.156Z" />
        </svg>
    );
};
